export default __webpack_public_path__ + "static/shopping-centre-5-e058442bda17a84a1d47d31e2fae8d4a.jpg";